(function () {
  const TRIGGER = [
    9961214837041, 9961188688177, 10471023477041,
    10536670331185, 10520509481265, 10499112304945,
    10536677998897, 10536676032817
  ];

  const CARDS = [
    10674763792689, 10676826145073, 10676827521329,
    10676827947313, 10676828373297, 10676829126961
  ];

  const HANDLES = [
    'メッセージカード-hello-new-baby',
    'メッセージカード-hello-big-sister',
    'メッセージカード-hello-big-brother',
    'メッセージカード-happy-birthday',
    'メッセージカード-thank-you',
    'メッセージカード-blank'
  ];

  const BAG_ID = 10861264109873;
  const BAG_HANDLE = 'white-paper-bag';
  const root = window.Shopify?.routes?.root || '/';
  const originalFetch = window.fetch.bind(window);

  let prevHadTrigger = false;
  let running = false;
  let checking = false;

  async function request(path, options) {
    const response = await originalFetch(root + path, options);
    let data;

    try {
      data = await response.json();
    } catch (error) {
      throw new Error('通信に失敗しました。もう一度お試しください。');
    }

    if (!response.ok) {
      throw new Error(data.description || '通信に失敗しました。');
    }

    return data;
  }

  async function addItem(id) {
    return request('cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: Number(id),
        quantity: 1
      })
    });
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  // テーマ由来の下線や装飾を抑え、ボタンの配色を統一する
  function styleButton(button, dark) {
    const styles = {
      display: 'block',
      visibility: 'visible',
      opacity: '1',
      width: '100%',
      'box-sizing': 'border-box',
      'margin-top': '12px',
      padding: '14px',
      background: dark ? '#222' : '#fff',
      color: dark ? '#fff' : '#222',
      border: '1px solid #222',
      'border-radius': '0',
      'background-image': 'none',
      'text-decoration': 'none',
      'text-transform': 'none',
      'box-shadow': 'none',
      'font-size': '14px',
      'line-height': '1.5',
      'font-family': 'inherit',
      'letter-spacing': 'normal',
      cursor: 'pointer',
      'flex-shrink': '0',
      appearance: 'none'
    };

    Object.entries(styles).forEach(function ([property, value]) {
      button.style.setProperty(property, value, 'important');
    });
  }

  // 不要ボタンにテーマの疑似要素で付く線も非表示にする
  if (!document.getElementById('ofune-gift-button-styles')) {
    const style = document.createElement('style');
    style.id = 'ofune-gift-button-styles';
    style.textContent = `
      #message-card-skip::before,
      #message-card-skip::after,
      #ofune-bag-yes::before,
      #ofune-bag-yes::after,
      #ofune-bag-no::before,
      #ofune-bag-no::after {
        display: none !important;
        content: none !important;
      }

      #mc-add-btn:disabled {
        opacity: .45 !important;
        cursor: not-allowed !important;
      }
    `;
    document.head.appendChild(style);
  }

  window.fetch = function (...args) {
    const input = args[0];
    const url =
      typeof input === 'string'
        ? input
        : input instanceof URL
          ? input.href
          : input?.url;

    return originalFetch(...args).then(function (response) {
      if (response.ok && url && url.includes('/cart/add')) {
        setTimeout(check, 500);
      }
      return response;
    });
  };

  async function check() {
    if (running || checking) return;

    checking = true;

    try {
      const cart = await request('cart.js');

      const hasTrigger = cart.items.some(function (item) {
        return TRIGGER.includes(item.product_id);
      });

      const alreadyHasCard = cart.items.some(function (item) {
        return CARDS.includes(item.product_id);
      });

      const shouldOpen = hasTrigger && !prevHadTrigger;
      prevHadTrigger = hasTrigger;

      if (shouldOpen) {
        running = true;

        if (alreadyHasCard) {
          await showBag();
        } else {
          await showCards();
        }
      }
    } catch (error) {
      running = false;
      console.error('Gift popup:', error);
    } finally {
      checking = false;
    }
  }

  function finish() {
    running = false;
    window.location.reload();
  }

  function trapFocus(container) {
    container.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;

      const focusable = Array.from(
        container.querySelectorAll(
          'button:not([disabled]), [tabindex="0"], a[href]'
        )
      ).filter(function (element) {
        return element.getClientRects().length > 0;
      });

      if (!focusable.length) {
        event.preventDefault();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (
        !event.shiftKey &&
        document.activeElement === last
      ) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  async function showBag() {
    const cart = await request('cart.js');

    if (
      cart.items.some(function (item) {
        return item.product_id === BAG_ID;
      })
    ) {
      finish();
      return;
    }

    document.getElementById('ofune-bag-popup')?.remove();

    const overlay = document.createElement('div');
    overlay.id = 'ofune-bag-popup';

    overlay.style.cssText = `
      position: fixed;
      inset: 0;
      height: 100dvh;
      box-sizing: border-box;
      z-index: 2147483647;
      background: rgba(0,0,0,.45);
      display: flex;
      align-items: flex-start;
      justify-content: center;
      overflow-y: auto;
      padding: 16px;
    `;

    overlay.innerHTML = `
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="ofune-bag-title"
        style="
          background:#fff;
          color:#222;
          width:100%;
          max-width:420px;
          box-sizing:border-box;
          padding:28px;
          text-align:center;
          max-height:calc(100dvh - 32px);
          overflow-y:auto;
          -webkit-overflow-scrolling:touch;
          overscroll-behavior:contain;
          margin-top:auto;
          margin-bottom:auto;
          flex-shrink:0;
        "
      >
        <h2 id="ofune-bag-title" style="font-size:20px;">
          お渡し用の白い紙袋を希望しますか？
        </h2>

        <div id="ofune-bag-image"></div>

        <p>無料で1点お付けします。</p>

        <button type="button" id="ofune-bag-yes">
          希望する
        </button>

        <button type="button" id="ofune-bag-no">
          不要
        </button>

        <p
          id="ofune-bag-error"
          role="alert"
          style="color:#b00020;"
        ></p>
      </div>
    `;

    document.body.appendChild(overlay);

    const yes = overlay.querySelector('#ofune-bag-yes');
    const no = overlay.querySelector('#ofune-bag-no');
    const errorBox = overlay.querySelector('#ofune-bag-error');

    styleButton(yes, false);
    styleButton(no, true);
    trapFocus(overlay);

    yes.focus();
    no.onclick = finish;

    let productPromise = null;

    function getBag() {
      if (!productPromise) {
        productPromise = request(
          'products/' + BAG_HANDLE + '.js'
        ).catch(function (error) {
          productPromise = null;
          throw error;
        });
      }

      return productPromise;
    }

    getBag().then(function (product) {
      if (!product.featured_image) return;

      const image = document.createElement('img');
      image.src = product.featured_image;
      image.alt = '白いお渡し用ペーパーバッグ';
      image.style.cssText =
        'max-width:180px;width:100%;height:auto;margin:12px auto;';

      overlay.querySelector('#ofune-bag-image').appendChild(image);
    }).catch(function () {
      // 画像を取得できなくても「不要」は選択できます。
    });

    yes.onclick = async function () {
      yes.disabled = true;
      no.disabled = true;
      yes.textContent = '追加しています…';
      errorBox.textContent = '';

      try {
        const currentCart = await request('cart.js');

        const alreadyHasBag = currentCart.items.some(function (item) {
          return item.product_id === BAG_ID;
        });

        if (!alreadyHasBag) {
          const product = await getBag();

          const variant = product.variants.find(function (item) {
            return item.available;
          });

          if (!variant) {
            throw new Error('紙袋は現在追加できません。');
          }

          await addItem(variant.id);
        }

        finish();
      } catch (error) {
        errorBox.textContent =
          '紙袋を追加できませんでした。' + error.message;

        yes.disabled = false;
        no.disabled = false;
        yes.textContent = '希望する';
        yes.focus();
      }
    };
  }

  async function showCards() {
    const overlay = document.getElementById(
      'message-card-popup-overlay'
    );

    const list = document.getElementById('message-card-list');
    const skip = document.getElementById('message-card-skip');

    if (!overlay || !list) {
      await showBag();
      return;
    }

    const products = await Promise.all(
      HANDLES.map(function (handle) {
        return request(
          'products/' + encodeURIComponent(handle) + '.js'
        ).catch(function () {
          return null;
        });
      })
    );

    const valid = products.filter(function (product) {
      return product && product.variants.some(function (variant) {
        return variant.available;
      });
    });

    if (!valid.length) {
      await showBag();
      return;
    }

    let selected = null;

    list.innerHTML = valid.map(function (product) {
      const title = product.title
        .replace(/^メッセージカード[｜|\s-]*/, '')
        .trim();

      const variant = product.variants.find(function (item) {
        return item.available;
      });

      const image = product.featured_image;

      return `
        <div
          class="mc-card-item"
          data-variant="${variant.id}"
          role="button"
          tabindex="0"
          aria-pressed="false"
        >
          ${
            image
              ? `<img
                  src="${escapeHtml(image)}"
                  alt="${escapeHtml(title)}"
                  loading="lazy"
                >`
              : ''
          }
          <span>${escapeHtml(title)}</span>
        </div>
      `;
    }).join('');

    document.getElementById('mc-add-btn')?.remove();
    document.getElementById('mc-error')?.remove();

    list.insertAdjacentHTML('afterend', `
      <button type="button" id="mc-add-btn" disabled>
        選ぶ
      </button>
      <p id="mc-error" role="alert" style="color:#b00020;"></p>
    `);

    const add = document.getElementById('mc-add-btn');
    const errorBox = document.getElementById('mc-error');

    styleButton(add, false);

    let busy = false;

    list.querySelectorAll('.mc-card-item').forEach(function (item) {
      function select() {
        if (busy) return;

        list.querySelectorAll('.mc-card-item').forEach(function (el) {
          el.classList.remove('selected');
          el.setAttribute('aria-pressed', 'false');
        });

        item.classList.add('selected');
        item.setAttribute('aria-pressed', 'true');

        selected = item.dataset.variant;
        add.disabled = false;
      }

      item.onclick = select;

      item.onkeydown = function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          select();
        }
      };
    });

    const newSkip = document.createElement('button');
    newSkip.id = 'message-card-skip';
    newSkip.type = 'button';
    newSkip.textContent = 'メッセージカードは不要';

    styleButton(newSkip, true);

    if (skip) skip.remove();
    add.insertAdjacentElement('afterend', newSkip);

    async function next() {
      overlay.style.display = 'none';
      await showBag();
    }

    newSkip.onclick = async function (event) {
      event.preventDefault();
      if (busy) return;

      busy = true;
      newSkip.disabled = true;

      try {
        await next();
      } catch (error) {
        busy = false;
        newSkip.disabled = false;
        overlay.style.display = 'flex';

        errorBox.textContent =
          '通信に失敗しました。もう一度お試しください。';
      }
    };

    add.onclick = async function () {
      if (!selected || busy) return;

      busy = true;
      add.disabled = true;
      newSkip.disabled = true;
      add.textContent = '追加しています…';
      errorBox.textContent = '';

      try {
        const cart = await request('cart.js');

        const alreadyHasCard = cart.items.some(function (item) {
          return CARDS.includes(item.product_id);
        });

        if (!alreadyHasCard) {
          await addItem(selected);
        }

        await next();
      } catch (error) {
        busy = false;
        add.disabled = false;
        newSkip.disabled = false;
        add.textContent = '選ぶ';
        overlay.style.display = 'flex';
        errorBox.textContent = error.message;
      }
    };

    overlay.style.setProperty('position', 'fixed', 'important');
    overlay.style.setProperty('inset', '0', 'important');
    overlay.style.setProperty('height', '100dvh', 'important');
    overlay.style.setProperty('box-sizing', 'border-box');
    overlay.style.setProperty('padding', '16px');
    overlay.style.setProperty('overflow-y', 'auto', 'important');
    overlay.style.setProperty('align-items', 'flex-start', 'important');

    let panel = list;

    while (
      panel.parentElement &&
      panel.parentElement !== overlay
    ) {
      panel = panel.parentElement;
    }

    if (panel.parentElement === overlay) {
      panel.style.setProperty('box-sizing', 'border-box');
      panel.style.setProperty(
        'max-height',
        'calc(100dvh - 32px)',
        'important'
      );
      panel.style.setProperty('min-height', '0', 'important');
      panel.style.setProperty('overflow-y', 'auto', 'important');
      panel.style.setProperty('-webkit-overflow-scrolling', 'touch');
      panel.style.setProperty('overscroll-behavior', 'contain');
      panel.style.setProperty('margin-top', 'auto');
      panel.style.setProperty('margin-bottom', 'auto');
      panel.style.setProperty('flex-shrink', '0');
    }

    list.style.setProperty('flex-shrink', '0');

    if (!overlay.dataset.ofuneFocusTrap) {
      trapFocus(overlay);
      overlay.dataset.ofuneFocusTrap = 'true';
    }

     overlay.style.display = 'flex';

    // フォーカスで下へ移動させず、先頭から表示する
    newSkip.focus({ preventScroll: true });

    requestAnimationFrame(function () {
      overlay.scrollTop = 0;
      panel.scrollTop = 0;
      list.scrollTop = 0;
    });

  }

  request('cart.js').then(function (cart) {
    prevHadTrigger = cart.items.some(function (item) {
      return TRIGGER.includes(item.product_id);
    });
  }).catch(console.error);
})();

